<script setup lang="ts">
//#region imports
import { provide } from 'vue';
//#endregion

//#region types
type TreeType = 'outer' | undefined;
type TreeThickness = 'thin' | 'medium';

interface Props {
  type?: TreeType;
  thickness?: TreeThickness;
}
//#endregion

//#region define
const props = withDefaults(defineProps<Props>(), {
  thickness: 'medium',
});
//#endregion

//#region composables
provide('type', props.type);
provide('thickness', props.thickness);
//#endregion
</script>

<template>
  <div
    :class="{
      'tree': true,
      'tree_type-outer': props.type === 'outer'
    }"
  >
    <slot />
  </div>
</template>

<style lang="scss">
  .tree{
    padding-left: 8px;
    &_type-outer {
      padding-left: 0;
    }
  }
</style>
